/*
 * Module for handling selecting a content mapping for associated content
 * or directly into a response
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/contentMapping/contentMappingView",
  "modules/shared/navTree/navTreeModule",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Messenger, ContentMappingView, NavTreeModule, SelectableListModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentMapping";
      this.namespace = options.namespace;
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.layout = new ContentMappingView.contentMappingLayout();
      this.tree = this.addSubModule(
        new NavTreeModule({
          region: this.layout.contentTree,
          nameAttribute: "groupName",
          namespace: this.namespace,
        }),
      );
      this.list = this.addSubModule(
        new SelectableListModule({
          namespace: this.namespace,
          region: this.layout.contentList,
        }),
      );
      //user selected a typeahead search item, so get the content (should be only one) from the server and
      //then select the matching piece content
      this.layout.on(
        "search",
        function (query) {
          const contentSearchResults = Messenger.reqres
            .request("search:content:by:mapping:name", query)
            .contents();
          contentSearchResults.onSynced(function () {
            //need to make sure that we return the content with the matching name (and not one that is a partial match)
            for (let i = 0; i < contentSearchResults.length; i++) {
              if (contentSearchResults.at(i).get("name") === query) {
                Messenger.vent.trigger(
                  Messenger.getFullName("mapping:search:selected", this.namespace),
                  contentSearchResults.at(i),
                );
                break;
              }
            }
          }, this);
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      const rootContentGroup = Messenger.reqres.request("root:content:group");
      this.tree.show(rootContentGroup);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("select:group", this.namespace),
        function (groupView) {
          console.log("mapping select!");
          this.list.show(groupView.model.contents());
        },
        this,
      );
    },
  });
});
